import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Product_Interface } from 'src/app/Interface/Product_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private http:HttpClient) { }


  GetRecord():Observable<Array<Product_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Product").pipe(
      map(data=>{
        return data as Array<Product_Interface>
      })
    )
  }

  GetSearchProduct(NameSearch:string):Observable<Array<Product_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Product/GetSearchProduct?NameSearch="+NameSearch).pipe(
      map(data=>{
        return data as Array<Product_Interface>
      })
    )
  }

  GetSingle(id:Number):Observable<Product_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/Product/GetSingle?id="+id).pipe(
      map(data=>{
        return data as Product_Interface
      })
    )
  }

  AddProduct(model: Product_Interface):Observable<Product_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      product_group_id:model.product_group_id,
      del:false,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Product/Add",body,{headers}).pipe(
        map(data=>{
          return data as Product_Interface
        })
      )

  }

  EditProduct(model: Product_Interface):Observable<Product_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      product_group_id:model.product_group_id,
      del:false,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Product/Edit",body,{headers}).pipe(
        map(data=>{
          return data as Product_Interface
        })
      )

  }

  DeleteProduct(id:number):Observable<Product_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/Product/Delete?id="+id).pipe(
        map(data=>{
          return data as Product_Interface
        })
      )

  }

}
